module.exports = require("./bez-TZ.js");